import { globalErrorHandler } from "@/helpers/globalResponseHandler";
import { api } from "@/lib/fetch/apiSetup";
import { ApiResponse } from "@/types/api/API";
import {
  SupportedDeviceResponseType,
  SupportedDeviceType,
} from "@/types/misc/CheckCompatibilityTypes";

const url =
  "https://portal.esimcard.com/api/get-supported-mobile-devices?key=esimcard-2001-101110-2030";

export async function getSupportedDeviceList(): Promise<
  ApiResponse<SupportedDeviceType[]>
> {
  try {
    const response = await api<SupportedDeviceResponseType>(url);

    return { status: true, data: response.data };
  } catch (error) {
    return { status: false, message: globalErrorHandler(error) };
  }
}
